<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 class="changelog">
        <v-tabs fixed-tabs v-model="tab">
          <v-tab key="changelog" ripple>
            <v-btn large icon @click="light = !light">
              <v-icon large :color="light ? 'amber' : 'black'">
                {{light ? 'mdi-lightbulb-on' : 'mdi-lightbulb'}}
              </v-icon>
            </v-btn>
            Changelog
          </v-tab>
          <v-tab key="stats" ripple>
            Stats
          </v-tab>

          <v-tab-item key="changelog">
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 24 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Restrictie incarcare pdf-uri</span>
            </h3>

            <p>
              Utilizatorii nu mai au posibilitatea sa incarce sau sa stearga pdf-uri. Le pot doar vizualiza. Singurii care mai pot incarca si sterge pdf-uri sunt adminii.
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 22 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Buton de marcare a pozelor incorecte</span>
            </h3>

            <p>
              App ofera acum posibilitatea de a marca pozele incorecte in cazul in care acestea nu se mai pot sterge.
              Functionalitatea este de tip comutare, adica ofera posibilitatea de a marca o poza ca fiind necorespunzatoare dar si pozibilitatea de a sterge acest marcaj (vezi demo in poze mai jos).
            </p>
            <p>
              (Fig. 1) Se observa butonul de marcare (<v-icon color="blue-grey" size="14">mdi-alert</v-icon>)
              si faptul ca prima poza este deja marcata ca fiind necorespunzatoare (<v-icon color="warning" size="14">mdi-alert</v-icon>).
            </p>
            <p>
              <img :src="`${url}/img/bad_photo_1.png`" style="vertical-align: middle; width: 100%; max-width: 200px">
            </p>
            <p>
              (Fig. 2) Se selecteaza primele 2 poze ( <span class="warning--text">()</span> ) si se apasa butonul de confirmare
              (<v-icon color="warning" size="16">mdi-check-circle</v-icon>).
            </p>
            <p>
              <img :src="`${url}/img/bad_photo_2.png`" style="vertical-align: middle; width: 100%; max-width: 200px">
            </p>
            <p>
              (Fig. 3) De pe prima poza a fost sters marcajul (<v-icon color="warning" size="14">mdi-alert</v-icon>),
              iar a doua poza a fost marcata ca fiind necorespunzatoare (<v-icon color="warning" size="14">mdi-alert</v-icon>).
            </p>
            <p>
              <img :src="`${url}/img/bad_photo_3.png`" style="vertical-align: middle; width: 100%; max-width: 200px">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 05 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Buton de resetare a informatiilor</span>
            </h3>

            <p>
              Fiecare camp are acum un buton de resetare a informatiilor (x) fiecarui camp editabil de catre utilizator (de ex. nu puteti resta adresa, sau zona, sau eticheta etc.).
              Exista si un buton de restare a intregului simbol, langa butonul de salvare si cel de undo (x).
              Singurul camp care nu poate fi resetat este centrul geometric.
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 02 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Upload fix attempt</span>
            </h3>

            <ul>
              <li>
                Exista cate un buton pentru fiecare camp in parte de la sectiunea "info lift" si care copiaza datele de la liftul <strong>ANTERIOR</strong>.
                <br>
                <img :src="`${url}/img/copy_lift_info.png`" style="vertical-align: middle; max-height: 8em">
              </li>
              <li>
                Am mai eliminat din animatii, tranzitii si efecte (inclusiv cele de schimbare a paginii de lucru).
              </li>
              <li>
                Testarea se face pe serverul de test (lifturi-s6.dragos.club). Utilizatorul va sti ca este in aplicatia de lucru sau cea de testarea dupa culorile aplicatiei:
                verde/portocaliu (
                  <v-icon small color="#009688">mdi-square</v-icon> / <v-icon small color="#ff5722">mdi-square</v-icon>
                ) pentru lucru si
                albastru/lime (
                  <v-icon small color="#2196F3">mdi-square</v-icon> / <v-icon small color="#CDDC39">mdi-square</v-icon>
                ) pentru test.
              </li>
              <li>
                Date test: <br>
                link: https://lifturi-s6.dragos.club
                email: test@tudconsult.ro
                pass: Test1!
              </li>
              <li>
                <strong>ATENTIE:</strong>
                Este vorba despre 2 servere total separate. Astfel, orice manipulare de date pe serverul de test NU SE PROPAGA pe serverul de lucru.
              </li>
            </ul>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 02 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Upload fix attempt</span>
            </h3>

            <p>
              Nu reusesc sa gasesc un pattern pentru situatiile in care nu merg adaugate (adaugare in acea bara de upload) poze sau incarcate (trimitere efectiva catre server, adica upload) poze...
              Pare sa se intample random sau mi-a scapat mie ceva esential...
              In acest context, am incercat sa acopar toate situatiile in care ar putea interveni erori.
              Astfel, in momentul in care modulul de upload ("worker") rapoarteaza o eroare in sectiunea de mesaje (<v-icon small>mdi-message-alert</v-icon>) avem la dispozitie 2 optiuni:
              <ul>
                <li><v-icon>mdi-worker</v-icon> Reincarcarea modulului (ar trebui sa opreasca incercarea de upload, daca exista vreuna) si apoi reluarea activitatii de adaugare/incarcare poze. Daca aveati poze adaugate si care asteptau sa se duca spre server, dupa actionarea butonului ar trebui sa fie acolo. Daca eroarea era la adaugare, atunci vor trebui readaugate pozele.</li>
                <li><v-icon>mdi-reload-alert</v-icon> Reincarcarea intregii aplicatii (care presupune ce am scris mai sus) ca sa evitam mecanismul de "sterge aplicatie, mergi in browser, da refresh, reinstaleaza aplicatie, bla bla bla" care este generator mare de frustrari. In mod normal, daca aplicatia da semne de oboseala, apasarea acestui buton ar trebui sa o "revigoreze".</li>
              </ul>

              <strong>Tip</strong>: In momentul in care apasati norisorul de upload, aplicatia testeaza conexiunea cu serverul trimitand un pachet mic de date si va notifica in mesaje (puteti activa mesajele manual cu butonul asta <v-icon small>mdi-message-alert</v-icon>).
              Daca dureaza mai mult de cateva secunde sa primiti mesaje de confirmare / infirmare inseamna ca:
              <ul>
                <li>ori nu s-a putut stabili o conexiune cu serverul din cauza netului slab;</li>
                <li>ori e vreo eroare prin aplicatie sau prin modulul de upload si trebuie reincarcata aplicatia (<v-icon small>mdi-reload-alert</v-icon>) sau modulul de upload (<v-icon small>mdi-worker</v-icon>).</li>
              </ul>
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 02 Octombrie</span>
              <span style="color: var(--v-info-darken1)">BIG CHANGE!!!</span>
            </h3>
            <p>
              In incercarea de a imbunatati functionalitatea aplicatie, s-a renuntat la feature-ul de "live data".
              Astfel, modificarile survenite la datele de pe server nu se vor mai propaga automat catre telefoane, ci se vor trimite notificari.
              In acest sens, butonul "clopotel" din dreapta sus, langa logout, a fost inlocuit cu un buton de "refresh".
              In momentul in care cineva schimba date in aplicatie, acel buton se va activa.
              La apasarea pe acel buton datele se vor reincarca.
              !Atentie! -> in momentul in care un utilizator modifica ceva in pagina de "detalii simbol", modificarile se vor propaga automat (desi se va activa si butnoul de refresh), dar DOAR pentru utilizatorul care le-a facut si doar daca acel utilizator este in continuare pe pagina de detalii.
              Daca un utilizator a modificat ceva la un simbol, cand iese din pagina de detalii va fi nevoit sa actioneze butonul "refresh" pentru a vedea modificarile in pagina "simboluri" si pe harta.
              Singurul impact asupra functionalitatii aplicatiei este ca datele din pagina "simboluri" si cele de pe harta sunt la stadiul ultimei apsari pe butonul "refresh" din aplicatie (nu refresh din browser, dar are cam acelasi efect).
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 01 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Updates</span>
            </h3>

            <p>
              A fost implementat un filtru nou pentru simbolurile editate.
              <img :src="`${url}/img/filtre_plus_editate.png`" style="vertical-align: middle">
              Filtrul se aplica inclusiv pe <strong>harta</strong> si are 3 stari:
              <ul>
                <li>Filtru dezactivat -> <img :src="`${url}/img/editate_dezactivat.png`" style="vertical-align: middle"></li>
                <li>Filtru activat, care afiseaza doar simbolurile editate -> <img :src="`${url}/img/editate.png`" style="vertical-align: middle"></li>
                <li>Filtru activat, care afiseaza doar simbolurile needitate -> <img :src="`${url}/img/needitate.png`" style="vertical-align: middle"></li>
              </ul>
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 01 Octombrie</span>
              <span style="color: var(--v-info-darken1)">Updates</span>
            </h3>

            <ul>
              <li>Info Consum: camp nou -> "Exista info despre consum"; Daca se bifeaza "Nu", cele 4 optiuni despre consum devin inaccesibile;</li>
              <li>Info Lift: camp nou -> "Exista info despre capacitate"; Aceeasi explicatie ca mai sus;</li>
              <li>Info lift: "An revizie" a fost modificat in "Anul ultimei revizii";</li>
              <li>Info lift: Camputi noi -> anul urmatoarei revizii &amp; Luna urmatoarei revizii (se intelege de la sine);</li>
              <li>Info lift: optiuni noi -> "Nu exista info" la "anul ultimei revizii", "anul urmatoarei revizii", "luna urmatoarei revizii".</li>
            </ul>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 30 Septembrie - Part 2</span>
              <span style="color: var(--v-info-darken1)">Updates</span>
            </h3>

            <ul>
              <li>Bara de upload mereu vizibila;</li>
              <li>Logout cu confirmare;</li>
              <li>Harta din Detalii are o inaltime mai mica (nu mai e patrata).</li>
              <li>Confirmare la modificarea pozitiei pin-ului pe harta in Detalii.</li>
              <!-- <li>Bara Detalii (cu save, undo, settings) fixa in partea de sus => mereu vizibila;</li>
              <li>Navigarea intre sectiunile din Detalii pe baza de taburi;</li> -->
            </ul>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 30 Septembrie - Part 1</span>
              <span style="color: var(--v-info-darken1)">Updates</span>
            </h3>

            <ul>
              <li>Filtru pe baza de zona;</li>
              <li>Filtrele activate in pagina <strong>Simboluri</strong> sunt aplicate si in pagina <strong>Harta.</strong></li>
            </ul>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Improvements</span>
            </h3>
            <p>
              Multe modificari:
              <ul>
                <li>posibilitatea de a adauga mai multe lifturi pentru o singura adresa;</li>
                <li>Pozele si documentele se incarca pe: scara si pe fiecare lift in parte;</li>
                <li>mesaje de atentionare pentru valori invalide;</li>
                <li>iconite diferite pentru adresele adaugate de utilizatori;</li>
                <li>info in log-ul de upload (acel meniu care permite stergerea pozelor/documentelor din coada de asteptare de upload)</li>
                <li>info despre fiecare camp in parte din pagina de detalii;</li>
                <li>info in pagina de poze&amp;pdf cu privire la apartenenta pozelor&amp;documentelor la lift/scara</li>
                <li>imposibilitatea de a mai adauga poze&amp;documente din pagina de poze&amp;pdf (ramane valabila functionalitatea de stergere);</li>
                <li>+ altele, probabil.</li>
              </ul>
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Symbol states</span>
            </h3>
            <p>
              In pagina de simboluri se afiseaza 3 stari: simbol "neatins", simbol "editat" dar neterminat, simbol "terminat".
              <img :src="`${url}/img/states.png`" style="max-height: 150px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Undo</span>
            </h3>
            <p>
              Utilizatorii au posibilitatea de a anula modificarile facute in pagina de detalii INAINTE DE SALVARE. Optiunea este accesibila atat pentru toate campurile dintr-un foc, cat si pentru fiecare camp in parte.
              <img :src="`${url}/img/undo.png`" style="max-height: 100px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Restriction - Regim inaltime</span>
            </h3>
            <p>
              Valoarea campului "regim inaltime" se calculeaza in timp real pe baza datelor din campurile "nr niveluri vizibile", "etaj tehnic vizibil", "comert servicii", "nr niveluri comert servicii".
              <img :src="`${url}/img/regim_inaltime.gif`" style="max-height: 200px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Improvement - Details page</span>
            </h3>
            <p>
              In pagina de detalii nu mai avem "collapsibles" (erau enervante si nu functionau corect pe iOS) ci mici carduri pentru fiecare camp.
              <img :src="`${url}/img/collapsibles.png`" style="max-height: 200px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Details page field settings</span>
            </h3>
            <p>
              Utilizatorul are posibilitatea de a alege ce campuri vor fi afisate in pagina de detalii. Setarile se salveaza local, pe dispozitivul utilizatorului.
              <img :src="`${url}/img/settings.gif`" style="max-height: 200px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Edit entity/simbol/POI/pin/marker position</span>
            </h3>
            <p>In pagina de detalii utilizatorul are posibilitatea de a modifica marker-ul/POI-ul pe harta.</p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Add entity/simbol/POI/pin/marker</span>
            </h3>
            <p>
              Utilizatorii au acum posibilitatea adaugarii de entitati noi.
              <img :src="`${url}/img/add_entity.gif`" style="max-height: 200px; display: block">
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - PDF upload</span>
            </h3>
            <p>
              S-a adaugat posibilitatea incarcarii si vizualizarii de documente PDF. Serverul verifica daca documentul este cu adevarat un PDF si il respinge in caz contrar (mesaj in log).
            </p>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Septembrie</span>
              <span style="color: var(--v-info-darken1)">Feature - Upload progress &amp; log</span>
            </h3>
            <p>
              S-a schimbat modalitatea de incarcare a pozelor astfel:
              <ul>
                <li>
                  pe langa bara de progres generala exista o bara de progres care indica in timp real upload-ul fiecarui fisier in parte;
                </li>
                <li>
                  cu fiecare upload efectuat se afiseaza un mesaj cu reusita/nereusita upload-ului; lista de mesaje contine ultimele 20 de mesaje; mesajele nu sunt salvate pe server, ci doar local, pe dispozitivul utilizatorului;
                </li>
                <li>
                  la fiecare start/resume upload se incearca determinarea vitezei de transfer si a duratei <strong>estimative</strong> prin trimiterea catre server a unui fisier mic (not very reliable, tho &#128542;);
                </li>
                <li>
                  lista de mesaje se deschide din bara de progress sau din butonul din title bar (langa logout).
                </li>
              </ul>
              <img :src="`${url}/img/upload_improvements.gif`" style="max-height: 400px; display: block">
            </p>

            <v-divider></v-divider>

            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-info-darken1)">Feature - Offline photos</span>
            </h3>
            <p>
              La incarcarea de poze, aplicatia salveaza o referinta locala a acestora.
              Asta inseamna ca aplicatia nu "uita" pozele atasate nici daca se inchide telefonul.
              Utilizatorul porneste manual upload-ul.
              Utilizatorul poate opri momentan upload-ul (actiunea intra efectiv in vigoare dupa ce se termina upload-ul pozei curente).
              Aplicatia detecteaza lipsa conexiunii la Internet si nu permite actionarea butonului de pornire upload (acest lucru este realizat printr-un joc de ping-pong pe care aplicatia il face cu serverul la fiecare 60 de secunde).
              Aplicatia semnaleaza conexiuni de tip lie-fi (viteza foarte mica) <strong>dar nu poate detecta viteze relativ mici</strong> (posibil de implementat pentru Android, feature lipsa pe iOS).
              Bara de progres se actualizeaza doar dupa upload-ul reusit al unei poze (upload pe chunks planificat).

              <img :src="`${url}/img/upload.png`" width="90%" style="max-width: 300px; display: block">
              <img :src="`${url}/img/lie-fi.png`" width="90%" style="max-width: 300px; display: block">
            </p>
            <p>
              <strong>Scenariu posibil</strong>: se fac poze, se incarca in aplicatie si se face upload-ul abia cand exista semnal puternic sau conexiune wi-fi.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">User - Delete poze</span>
            </h3>
            <p>
              Oirice <em>user</em> poate sterge poze atata timp cat au fost incarcate de el si nu au trecut 10 minute.
              Neindeplinirea conditiilor duce la <strong>silent fail</strong>.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">User - Delete poze</span>
            </h3>
            <p>
              Oirice <em>user</em> vede in UI optiunea de stergere poze, indiferent de conditii.
              <br>
              <img :src="`${url}/img/delete-photo-ui.png`" height="36">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">Desktop - Tooltip butoane</span>
            </h3>
            <p>
              Fiecare buton are tooltip explicativ la mouseover. Valabil doar pe desktop.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-primary-base)">Admin - Evidentiere simbol harta</span>
            </h3>
            <p>
              La navigarea din lista de Simboluri catre un simbol pe harta, acel simbol primeste o animatie bounce.
              <br>
              <img :src="`${url}/img/bounce.gif`" height="64">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-14</span>
              <span style="color: var(--v-info-darken1)">Fix - Filtre + Search</span>
            </h3>
            <p>
              Filtrele functioneaza si in combinatie cu campul de cautare.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">Admin - Export XLSX</span>
            </h3>
            <p>
              2 butoane pentru exportul informatiilor in format xlsx pe baza unui template predefinit.
              Se esxclude centrul geometric (coloanele nu se populeaza dar raman).
              Se adauga coloana "nr poze".
            </p>
            <p>
              Un buton exporta toate informatiile, ignorand filtere, eticheta si paginatia. Poate fi considerat un export al bazei de date (minus centru geografic)
              <img :src="`${url}/img/download-xlsx-all.png`" height="14">
            </p>
            <p>
              Un buton exporta tinand cont de filtre, etichete si paginatie.
              <img :src="`${url}/img/download-xlsx-filters.png`" height="14">
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">Admin - Import XLSX eticheta</span>
            </h3>
            <p>
              La import se specifica o eticheta pentru simbolurile incarcate. Eticheta devine parte a filtrelor.
            </p>
            <h3>
              <span class="subheading mr-2" style="color: var(--v-accent-darken2)">2019 Mai-13</span>
              <span style="color: var(--v-primary-base)">User - Filtru eticheta</span>
            </h3>
            <p>
              Simbolurile se filtreaza si dupa eticheta (etichtele au afisata si data in care s-a facut importul).
              Se pot afisa toate simbolurile (impact performanta pe harta) prin stergerea filtrului.
              <br>
              <img :src="`${url}/img/eticheta.png`" height="32">
            </p>
          </v-tab-item>
          <v-tab-item key="stats">
            <v-list three-line>
              <v-list-tile v-for="user in stats.users" :key="user._id">
                <v-list-tile-avatar>
                  <v-avatar>
                    <v-icon large>mdi-account-circle</v-icon>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ user.username }}</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-icon small>mdi-map-marker</v-icon>
                    {{ user.simboluri }}
                    <v-icon small class="ml-4">mdi-image</v-icon>
                    {{ user.photos }}
                    <br>
                    <template v-for="label in user.etichete">
                      <span :key="label._id + '_label'">{{ label._id }}</span>
                      <v-icon small :key="label._id + '_icon'">mdi-label</v-icon>
                      <span :key="label._id + '_count'" class="ml-1 mr-2">{{ label.count }}</span>
                    </template>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-tab-item>
      </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'

export default {
  name: 'app-home',
  data: () => ({
    url: SERVER_URL,
    tab: null
  }),
  watch: {
    tab (value) {
      if (value) {
        this.$store.dispatch('getStats')
      }
    }
  },
  computed: {
    light: {
      get () {
        return this.$store.getters.light
      },
      set (value) {
        this.$store.commit('setLight', value)
      }
    },
    stats () {
      return this.$store.getters.stats
    }
  }
}
</script>
